import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import {AirlineNotification} from "../../shared/interfaces/airline-notification";
import {NDCApiService} from "../../shared/services/ndc-api.service";
import {ErrorAlert} from "../../shared/models/error-alert";
import {HelpersService} from "../../shared/services/helpers.service";
import { OrderHistoryItem } from '../../shared/interfaces/order-history';

@Component({
  selector: 'app-airline-notification-modal',
  templateUrl: './airline-notification-modal.component.html',
  styleUrls: ['./airline-notification-modal.component.scss']
})
export class AirlineNotificationModalComponent implements OnChanges, OnInit {

  @Input() orderID: string;
  @Input() airlineID: string;
  @Input() airlineNotification: AirlineNotification;
  @Input() orderHistory: OrderHistoryItem[];
  @Output() emitClose = new EventEmitter();
  @Output() emitButtonClick = new EventEmitter<string>();
  @Output() emitNotificationChange = new EventEmitter();
  @Output() emitOrderRefresh = new EventEmitter();

  flightDiffsToShow: any[];

  orderNotificationSeenToggleError: ErrorAlert = new ErrorAlert();

  constructor(private ndcApiService: NDCApiService, private helpers: HelpersService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['orderHistory'] && changes['orderHistory'].currentValue) {
      const updatedOrderHistory = changes['orderHistory'].currentValue as any[];

      const lastOrderRetrieve = [...updatedOrderHistory]
        .reverse()
        .find(entry =>
          entry.eventID === 'OrderRetrieve' &&
          entry.details?.flightDetailsDiff?.length > 0
        );

      if (lastOrderRetrieve) {
        this.flightDiffsToShow = lastOrderRetrieve.details.flightDetailsDiff;
      }
    }
  }
  ngOnInit(): void {
    setTimeout(() => {
      this.checkForOrderRetrieveAfterNotification();
    });
  }

  private checkForOrderRetrieveAfterNotification(): void {
    const lastNotification = [...this.orderHistory].reverse().find(entry => entry.airlineNotification);

    const hasOrderRetrieveAfterLastNotification = this.orderHistory
      .slice(this.orderHistory.indexOf(lastNotification))
      .some(entry => entry.eventID === 'OrderRetrieve');

    if (!hasOrderRetrieveAfterLastNotification) {
      this.emitOrderRefresh.emit();
    }
  }

  onNotificationChange() {
    this.orderNotificationSeenToggleError = new ErrorAlert();
    const body = {
      id: this.orderID,
      notificationIds: [this.airlineNotification.id]
    };
    this.ndcApiService.orderNotificationSeenToggle(body, false).then((res) => {
      this.airlineNotification = res.airlineNotifications.find((airlineNotification: AirlineNotification) => airlineNotification.id === this.airlineNotification.id);
      this.emitNotificationChange.emit(res);
    }).catch((err) => {
      this.orderNotificationSeenToggleError = this.helpers.getError(err);
    });
  }

}
